import { FC } from 'react';
import { Grid, Typography } from '@mui/material';
import { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';

interface IAcceptedDetails {
  statusText?: string;
}

export const AcceptedDetails: FC<IAcceptedDetails> = ({ statusText }) => {
  const classes = useStyles();

  return (
    <>
      <Grid container>
        <Grid item xs={12} sm={6}>
          <Typography className={classes.readOnlyHeaders} variant="h6">
            Build Info
          </Typography>
          <Typography variant="subtitle1" className={classes.statusText}>
            <span className={classes.detailsLabel}>Status:</span> {statusText} <br />
          </Typography>
          <Typography variant="subtitle1">
            This contract has been accepted and an Email has been sent to the Buyer with Login Instructions for completing their 10 day options.
          </Typography>
        </Grid>
      </Grid>
    </>
  );
};

const useStyles = makeStyles((theme: Theme) => ({
  readOnlyHeaders: {
    paddingBottom: theme.spacing(0.25),
    fontWeight: '700'
  },
  detailsLabel: {
    fontWeight: 'bold'
  },
  statusText: {
    paddingBottom: '8px'
  }
}));
